import { useEffect, useState } from 'react';
import {
  Button,
  ChevronDownIcon,
  Flex,
  FormControl,
  FormLabel,
  Menu,
  MenuButton,
  MenuFuseHighlight,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  MenuSearchBox,
  MenuSearchBoxOption,
  VirtualizedList,
} from '@cdl/heartbeat-react';
import { FormValues } from '../../../types/annotation-task-detail.type';
import { Control, UseFormRegister, useWatch } from 'react-hook-form';

type Props = {
  options: MenuSearchBoxOption[];
  handleDataChange: (value: string) => void;
  register: UseFormRegister<FormValues>;
  type: string;
  required?: boolean;
  control: Control<FormValues>;
};

export const DropdownSingleData: React.FC<Props> = ({
  options,
  handleDataChange,
  type,
  register,
  required = false,
  control,
}) => {
  const [selectedOption, setSelectedOption] = useState<string>();
  const label = options.find(
    (item) => item.value === selectedOption,
  )?.displayValue;

  const value = useWatch({ control, name: type });
  useEffect(() => {
    if (value === '') {
      setSelectedOption('');
    }
  }, [value]);

  return (
    <FormControl pb='m'>
      <>
        <input
          {...register(type, {
            required: required ? 'This is required' : undefined,
          })}
          style={{ display: 'none' }}
        />
      </>
      <Menu
        closeOnSelect={true}
        autoSelect={false}
        variant='virtual'
        matchWidth
      >
        <FormLabel htmlFor={type}>
          {type}
          {required && '*'}
        </FormLabel>
        <MenuButton
          as={Button}
          variant='secondary'
          w='full'
          textAlign='left'
          fontWeight='regular'
          rightIcon={<ChevronDownIcon />}
        >
          {label ? label : `Select ${type}`}
        </MenuButton>
        <MenuList maxWidth='unset' zIndex={40}>
          <MenuSearchBox
            options={options}
            placeholder='Search...'
            fuseOptions={{
              ignoreLocation: true,
              ignoreFieldNorm: true,
            }}
          >
            {(filteredOptions) => (
              <Flex flexDirection='column'>
                <VirtualizedList
                  rowHeight={35}
                  containerHeight={300}
                  size={filteredOptions.length || options.length}
                >
                  {(virtualItems) => (
                    <MenuOptionGroup
                      onChange={(value) => {
                        handleDataChange(value as string);
                        setSelectedOption(value as string);
                      }}
                      value={selectedOption}
                      type='radio'
                    >
                      {virtualItems.map(({ index, key, style }) => {
                        if (filteredOptions.length > 0) {
                          const fuseOption = filteredOptions[index];
                          return (
                            <MenuItemOption
                              value={fuseOption.item.value}
                              key={key}
                              style={style}
                            >
                              <MenuFuseHighlight
                                fallback={fuseOption.item.value}
                                hit={fuseOption}
                              />
                            </MenuItemOption>
                          );
                        }
                        const { value, displayValue } = options[index];
                        return (
                          <MenuItemOption value={value} key={key} style={style}>
                            {displayValue}
                          </MenuItemOption>
                        );
                      })}
                    </MenuOptionGroup>
                  )}
                </VirtualizedList>
              </Flex>
            )}
          </MenuSearchBox>
        </MenuList>
      </Menu>
    </FormControl>
  );
};
